/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Cadence_RangeInputs */

const en_exp_cadence_range = /** @type {(inputs: Exp_Cadence_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Running: 160–180+ spm (elite often 180+). Cycling: 80–100 rpm (varies by terrain and effort). Lower cadence = more muscular load, higher cadence = more cardiovascular load.`)
};

const de_exp_cadence_range = /** @type {(inputs: Exp_Cadence_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laufen: 160–180+ spm (Elite oft 180+). Radfahren: 80–100 rpm (je nach Gelände und Anstrengung). Niedrig = mehr muskulär, hoch = mehr kardiovaskulär.`)
};

/**
* | output |
* | --- |
* | "Running: 160–180+ spm (elite often 180+). Cycling: 80–100 rpm (varies by terrain and effort). Lower cadence = more muscular load, higher cadence = more cardi..." |
*
* @param {Exp_Cadence_RangeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const exp_cadence_range = /** @type {((inputs?: Exp_Cadence_RangeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Cadence_RangeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exp_cadence_range(inputs)
	return de_exp_cadence_range(inputs)
});